import store from '~/redux/store'
import { updateDeviceConnectionState } from '~/redux/actions/actions'

export default (deviceId, { online }) => {
  store.dispatch(updateDeviceConnectionState({
    deviceId,
    online,
  }))
}
